import type { VNode } from 'vue';
import type { WithEvents } from 'vue-typed-emit';

import type { ComponentListeners } from '../../types';
import { UidMixin } from '../../mixins';

import type { ToggleEvents } from './Toggle.types';

export default (UidMixin as WithEvents<ToggleEvents, typeof UidMixin>).extend({
  name: 'SldsToggle',
  model: {
    prop: 'checked',
    event: 'change',
  },
  inheritAttrs: false,
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    listeners(): ComponentListeners {
      return {
        ...this.$listeners,
        change: (e: InputEvent) => {
          e.preventDefault();
          this.$emit('change', (e.target as HTMLInputElement).checked);
        },
      };
    },
  },
  render(h): VNode {
    return h('div', { staticClass: 'slds-form-element' }, [
      h('label', { staticClass: 'slds-checkbox_toggle slds-grid' }, [
        h(
          'span',
          { staticClass: 'slds-form-element__label slds-m-bottom_none' },
          this.label
        ),
        h('input', {
          domProps: { checked: this.checked },
          attrs: {
            ...this.$attrs,
            type: 'checkbox',
            'ari-described-by': this.uid,
          },
          on: this.listeners,
        }),
        h(
          'span',
          {
            attrs: { id: this.uid, 'aria-live': 'assertive' },
            staticClass: 'slds-checkbox_faux_container',
          },
          [
            h('span', { staticClass: 'slds-checkbox_faux' }),
            h('span', { staticClass: 'slds-checkbox_on' }, 'Enabled'),
            h('span', { staticClass: 'slds-checkbox_off' }, 'Disabled'),
          ]
        ),
      ]),
    ]);
  },
});
